module.exports = __webpack_public_path__ + "img/ios登录.cf062961.png";